/**
 * @Description
 */
import React from 'react';

export const CollectListContext = React.createContext<any>(null);

export interface district {
  code:string;
  id:number;
  lat:string|number;
  lng:string|number;
  name:string;
}
export interface mapInfo{
  city:any;
  district:any;
  level:number;
}
// 当前选中的行政区信息
export interface curSelectDistrictType {
  districtInfo :district[];
  cacheMapInfo:mapInfo|null;
}

// 区以下聚合的临界条件
export const CLUSTER_CRITICAL_COUNT = 500;

// 左下地图工具箱
export const mapToolBoxImg = [
  'https://staticres.linhuiba.com/project-custom/locationpc/map/icon_network_putong.png',
  'https://staticres.linhuiba.com/project-custom/locationpc/map/icon_network_weixing.png',
  'https://staticres.linhuiba.com/project-custom/locationpc/map/icon_network_renkoureli.png',
  'https://staticres.linhuiba.com/project-custom/locationpc/map/icon_network_canyinreli.png',
];


export const rankIcon = [
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/pointone.png' },
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/pointtwo.png' },
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/pointthree.png' },
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/marker.png' },
];
export const selectRankIcon = [
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/selectone.png' },
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/selecttwo.png' },
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/selectthree.png' },
  { url: 'https://staticres.linhuiba.com/project-custom/locationpc/map/selectmarker.png' },
];
export const newCreateIcon = 'https://staticres.linhuiba.com/project-custom/locationpc/map/siteSelection_map_ic.png';
export enum mapToolEnum {
  normal = 'normal',
  satellite = 'satellite',
  population = 'population',
  food = 'food'
}

// 筛选项枚举
export enum sectionKey {
  sortRule = 'sortRule', // 排名规则
  sortRuleMenu = 'sortRuleMenu', // 排名规则
  firstLevelCategory='firstLevelCategory', // 开店区域类型
  categoryMenu = 'categoryMenu', // 开店区域类型
  secondLevelCategoryCultureEducation='secondLevelCategoryCultureEducation', // 文教型
  secondLevelCategoryCommunity='secondLevelCategoryCommunity', // 社区型
  secondLevelCategoryTraffic='secondLevelCategoryTraffic', // 交通枢纽型
  secondLevelCategoryStreet='secondLevelCategoryStreet', // 街铺商圈型
  secondLevelCategoryOffice='secondLevelCategoryOffice', // 办公型
  secondLevelCategoryBusiness='secondLevelCategoryBusiness', // 商场型
  secondLevelCategoryScenicSpot='secondLevelCategoryScenicSpot', // 景区型
  secondLevelCategoryCompound='secondLevelCategoryCompound', // 复合型
  area = 'area', // 行政区--no,
  districtMenu = 'districtMenu', // 行政区--no,
  labelSystemMall = 'labelSystemMall', // 开店区域标签
  labelSystemHighQuality = 'labelSystemHighQuality', // 商圈特性
  preferBrand='preferBrand',
  preferBrandMenu = 'preferBrandMenu', // 偏好品牌--no
  avoidBrand = 'avoidBrand', // 避开品牌--no
  avoidBrandMenu = 'avoidBrandMenu', // 避开品牌--no
  cateringStore = 'cateringStore', // 餐饮门店数
  oldCateringStore = 'oldCateringStore', // 餐饮老店占比
  population = 'population', // 周边人口
  marketScore = 'marketScore', // 市场评分
  marketScoreMenu = 'marketScoreMenu', // 市场评分
  passFlow = 'passFlow', // 商场日均客流指数
  housePrice = 'housePrice', // 周边房屋均价
  facility='facility', // 周边配套（500m）
  workType ='workType', // 办公
  schoolType = 'schoolType', // 学校
  trafficType='trafficType', // 交通
  scenicType='scenicType', // 景区
  medicalType ='medicalType', // 医院
  otherType = 'otherType', // 其他市场
  households = 'households', // 小区户数
  houseYear = 'houseYear', // 小区建筑年代
  tourBrand='tourBrand', // 巡展品牌
  tourBrandMenu='tourBrandMenu', // 巡展品牌
  developerBrand='developerBrand', // 开发商品牌
  labelSystemSource='labelSystemSource', // 来源
  brand='brand', // 本品牌门店
  competitorBrand='competitorBrand', // 竞品品牌
}
export const secondLevel = [
  sectionKey.secondLevelCategoryCultureEducation,
  sectionKey.secondLevelCategoryCommunity,
  sectionKey.secondLevelCategoryTraffic,
  sectionKey.secondLevelCategoryStreet,
  sectionKey.secondLevelCategoryOffice,
  sectionKey.secondLevelCategoryBusiness,
  sectionKey.secondLevelCategoryScenicSpot,
  sectionKey.secondLevelCategoryCompound,
];
export const leftListSelectionDOM = 'leftListSelectionDOM';

export const layerSection = [
  { label: '本品牌门店', code: 'brand' },
  { label: '竞品门店', code: 'competitorBrand' }
];
export const facilityList = [
  { label: '办公', key: sectionKey.workType },
  { label: '学校', key: sectionKey.schoolType },
  { label: '交通', key: sectionKey.trafficType },
  { label: '景区', key: sectionKey.scenicType },
  { label: '医院', key: sectionKey.medicalType },
  { label: '其他市场', key: sectionKey.otherType },
];
export const facilityListKeys = [sectionKey.workType, sectionKey.schoolType, sectionKey.trafficType, sectionKey.scenicType, sectionKey.medicalType, sectionKey.otherType];

export const creating = 'creating';
export const collecting = 'collecting';
export const allData = 'allData';
// export const creatingOption = { key: creating, name: '生成中', value: creating };
// export const rankOptions:any[] = [
//   { key: creating, name: '生成中', value: creating },
//   { key: collecting, name: '收藏', value: collecting },
//   { key: 'rank', name: '全部', value: allData },
//   { key: 'rank20', name: '前20名', value: 20 },
//   { key: 'rank50', name: '前50名', value: 50 },
//   { key: 'rank100', name: '前100名', value: 100 },
//   { key: 'rank200', name: '前200名', value: 200 },
//   { key: 'rank300', name: '前300名', value: 300 },
//   { key: 'rank500', name: '前500名', value: 500 },
// ];

export enum tabsKey {
  energy = 'energy',
  all = 'all'
}
export const carBrandRadio = [
  { label: '所有品牌', key: tabsKey.all },
  { label: '能源类型', key: tabsKey.energy },
];

// 类名
export const mapCon = 'mapCon';
export const addBusiness = 'addBusinessBtn';
export const networkMapContainer = 'networkMapContainer';
export const topCon = 'topCon';

// 服务端说不能写枚举，id又自增，只能通过中文匹配
export enum businessType{
  recommend = '推荐开店区域',
  new = '新增开店区域'
}

export enum leftTab{
  condition = '条件筛选',
  layer = '图层设置'
}

export const lastDataStorage = 'lastDataStorage1';

// export enum firstLevelCategoryIdEnum {
//   businessCategory = 1, // 商业区
//   communityCategory, // 社区型
//   cultureEducationCategory, // 文教型
//   transportationJunctionCategory, // 交通枢纽型
//   workCategory, // 办公型
//   scenicAreaCategory, // 景区型
//   recombinationCategory, // 复合型
//   streetShopCategory, // 街铺
//   healthCareCategory, // 医疗保健 9
//   carTradeMartCategory, // 汽车城 10
// }



export enum industryCodeEnum{
  /**
     * 中餐厅
     */
  chineseRestaurant = 1,
  /**
   * 外国餐厅
   */
  foreignRestaurant=2,
  /**
   * 小吃快餐
   */
  snack=3,
  /**
   * 咖啡
   */
  coffee=4,
  /**
   * 奶茶饮品
   */
  milkTea=5,
  /**
   * 面包甜品
   */
  bread=6,

  /**
   * 汽车
   */
  carSale=7,

  /**
   * 服饰鞋包
   */
  clothing=8,
  /**
   * 超市便利
   */
  supermarket=9,

  /**
   * 个护美妆
   */
  beauty=10,
  /**
   * 医药保健
   */
  medicine=11,
}
// 前端判断用
export enum RangeSelectEnum {
  'inPolygon' = 'inPolygon',
  '100m' = 100,
  '200m' = 200,
  '300m' = 300,
  '500m' = 500,
  '1km' = 1000,
}
export function getValueByRangeEnum(rangeEnum) {
  switch (rangeEnum) {
    case 0:
      return RangeSelectEnum.inPolygon;
    case 1:
      return RangeSelectEnum['100m'];
    case 2:
      return RangeSelectEnum['200m'];
    case 3:
      return RangeSelectEnum['300m'];
    case 5:
      return RangeSelectEnum['500m'];
    case 10:
      return RangeSelectEnum['1km'];
    default:
      return RangeSelectEnum.inPolygon;
  }
}
// https://yapi.lanhanba.com/project/546/interface/api/88564
export function getServiceEnum(value:RangeSelectEnum) {
  switch (value) {
    case RangeSelectEnum.inPolygon:
      return 0;
    case RangeSelectEnum['100m']:
      return 1;
    case RangeSelectEnum['200m']:
      return 2;
    case RangeSelectEnum['300m']:
      return 3;
    case RangeSelectEnum['500m']:
      return 5;
    case RangeSelectEnum['1km']:
      return 10;
    default:
      return null;
  }
}
/** page为0的时候代表没有更多的数据了 */
export const NOT_MORE_DATA = 0;

/** 小区的业态key，目前依赖数据部门，写死为1 */
export const COMMUNITY_KEY = '1';
